<template>
  <header class="steps">
    <nav>
      <a href="#" @click.prevent="" v-for="step in steps" :key="step" :class="step.status">
        <div>
          {{ step.title }}
        </div>
        <div class="statusbar">
          <span :style="{width: `${step.exec}%`}"></span>
        </div>
      </a>
    </nav>      
  </header>
</template>

<script>
export default {
  props: {
    steps: Array
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .steps {
    width: auto; padding: $hmg_mid;

    nav{
      display: flex; align-content: center; align-items: center;
      justify-content:center;
      gap: $mg_mini; margin: $hmg_mid 0;

      a {
        display: inline-flex;
        flex-direction: column; align-items: center; flex-shrink: 0;
        gap: $hmg_mini;
        width: 120px;
        text-align: center;
        font-weight: 600;

        .statusbar {
          width: 100%;
          height: 4px;
          border-radius: 2em;
          background-color: $color-mid-grey;
          overflow: hidden;
          @extend %transition_3o;

          >span {
            display: block; height: 100%;
            min-width: 0;
            padding: 0;
            @extend %transition_3o;
          }
        }

        &.idle {
          pointer-events: none;
        }

        &:not(.idle) {
          font-size: $font-size-large;
          font-weight: 900;
          pointer-events: none;

          .statusbar {
            height: 6px;
          }
        }

        &.active {
          color: $color-primary;

          .statusbar {
            background: $color-secondary;

            >span {
              background-color: $color-primary;
            }
          }
        }
        &.error {
          color: $color-primary;

          .statusbar {
            background: $color-secondary;

            >span {
              background-color: $color-primary;
            }
          }
        }
      }
    }
  }
</style>